import React from 'react'

const ClockIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="8" stroke="#FF5612" strokeWidth="1.5" />
            <path d="M12 8.7998V11.7322C12 11.8994 12.0836 12.0555 12.2226 12.1482L14.4 13.5998" stroke="#FF5612" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    )
}

export default ClockIcon